import { AppState } from "@Safemate/Store/types";
import { RootState } from "./types";

export const getLanguageCode = ({ appData: { user: { languageCode } } }: AppState) => languageCode;

export const getFilter = ({ translationPage: {filter} }: AppState) => filter;

export const getUnfilteredTextLabels = ({ translationPage: {textLabel: { textLabels }}}: AppState) => textLabels; 